import * as React from "react";

import {
  TermsAndConditions as TermsAndConditionsComponent,
  TermsAndConditionsProps as TermsAndConditionsComponentProps,
} from "../../components/TermsAndConditions/TermsAndConditions";

type TermsAndConditionsProps = TermsAndConditionsComponentProps;

export default class extends React.Component<TermsAndConditionsProps> {
  render() {
    return <TermsAndConditionsComponent {...this.props} />;
  }
}
